
import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/e4140a6110134fefa958645e77b5a66a/cc1f1316833ca510742f9737478242fc.png"
              alt="Gleimatus Empreendimentos"
              className="h-12 w-auto cursor-pointer"
              onClick={() => scrollToSection('hero')}
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('sobre')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-400'
              }`}
            >
              Sobre Nós
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-400'
              }`}
            >
              Portfólio
            </button>
            <button
              onClick={() => scrollToSection('missao')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-400'
              }`}
            >
              Missão
            </button>
            <button
              onClick={() => scrollToSection('valores')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-400'
              }`}
            >
              Valores
            </button>
            <button
              onClick={() => scrollToSection('clientes')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-400'
              }`}
            >
              Clientes
            </button>
            <button
              onClick={() => scrollToSection('qualidade')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-400'
              }`}
            >
              Qualidade
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-700 hover:to-amber-600 text-white font-semibold px-6 py-2 rounded-full transition-all duration-300 shadow-lg hover:shadow-amber-500/50 whitespace-nowrap cursor-pointer"
            >
              Contato
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
            }`}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-gray-200/20">
            <nav className="py-4 space-y-2">
              <button
                onClick={() => scrollToSection('sobre')}
                className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-amber-50 hover:text-amber-600 transition-colors cursor-pointer"
              >
                Sobre Nós
              </button>
              <button
                onClick={() => scrollToSection('portfolio')}
                className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-amber-50 hover:text-amber-600 transition-colors cursor-pointer"
              >
                Portfólio
              </button>
              <button
                onClick={() => scrollToSection('missao')}
                className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-amber-50 hover:text-amber-600 transition-colors cursor-pointer"
              >
                Missão
              </button>
              <button
                onClick={() => scrollToSection('valores')}
                className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-amber-50 hover:text-amber-600 transition-colors cursor-pointer"
              >
                Valores
              </button>
              <button
                onClick={() => scrollToSection('clientes')}
                className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-amber-50 hover:text-amber-600 transition-colors cursor-pointer"
              >
                Clientes
              </button>
              <button
                onClick={() => scrollToSection('qualidade')}
                className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-amber-50 hover:text-amber-600 transition-colors cursor-pointer"
              >
                Qualidade
              </button>
              <button
                onClick={() => scrollToSection('contato')}
                className="block w-full text-left px-4 py-3 bg-gradient-to-r from-amber-600 to-amber-500 text-white font-semibold rounded-lg mx-4 mt-2 transition-all duration-300 cursor-pointer"
              >
                Contato
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}